module.exports = __webpack_public_path__ + "static/media/Saly-1.e4f6eed2.jpg";